<app-nav-bar></app-nav-bar>
<app-dashboard-bar></app-dashboard-bar>

<div class="settings_page container flex">
  <div class="side_tabs-container">
    <app-side-settings></app-side-settings>
  </div>

  <div class="right_side-container">
    <app-edit></app-edit>
  </div>
</div>